<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"><strong> Complete</strong></h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">
        <div class="ui violet floating message m-4">
          <div class="header mb-2">
            TN CyberTech Bank
          </div>
          <p>Thank You For Choosing TN CyberTech Bank, in approximately 10 seconds you will be asked to confirm your Ecocash pin so that
            we can accept your account opening request.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
  name: 'ISaveComplete',
  data() {
  return {customer : {
  mobileNumber : ""
  },
    errors: {},
      operations: 0,
  };
  },
  mounted() {},
  methods: {
      close() {
      // todo: send close request to backend
    },
    submitForm() {
        localStorage.setItem("phone-number", this.customer.mobileNumber);
        this.$router.push("/account-opening/customer-details");
    },
    ...baseMethods,
  }
};
</script>